import Swiper, {Navigation, Pagination} from 'swiper';
Swiper.use([Navigation, Pagination]);

const initReviewsSlider = () => {
  const sliderContainers = document.querySelectorAll('.reviews');
  sliderContainers.length && sliderContainers.forEach((sliderContainer) => {
    const slider = sliderContainer.querySelector('.reviews__slider');

    new Swiper(slider, {
      loop: true,
      effect: 'slide',
      spaceBetween: 20,
      breakpoints: {
        1441: {
          slidesPerView: 5,
        },
        1171: {
          slidesPerView: 4,
        },
        651: {
          slidesPerView: 2,
        },
        501: {
          slidesPerView: 1.5,
        },
        0: {
          slidesPerView: 1,
        },
      },
      navigation: {
        nextEl: sliderContainer.querySelector('.slider-navigation__button--next'),
        prevEl: sliderContainer.querySelector('.slider-navigation__button--prev'),
      },
      pagination: {
        el: sliderContainer.querySelector('.swiper-pagination'),
        type: "fraction",
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Переход на предыдущий слайд',
        nextSlideMessage: 'Переход на следующий слайд',
      },
    });

    const videoReviews = sliderContainer.querySelectorAll('.reviews__slide');
    videoReviews?.forEach((videoReview) => {
      videoReview.addEventListener("mouseover", () => videoReview.querySelector("video")?.play());

      videoReview.addEventListener("mouseleave", () => videoReview.querySelector("video")?.pause());
    });
  });
   
  sliderContainers.length && sliderContainers.forEach((sliderContainer, index) => {
    const dublicateSlides = sliderContainer.querySelectorAll('.swiper-slide-duplicate');
    dublicateSlides?.forEach((slide, indexSlide) => {
      slide.querySelector('.reviews__slide-play')?.setAttribute('data-fslightbox', `dublicate-review-${index + 1}-${indexSlide + 1}`);
    });      
  });
   
  refreshFsLightbox();
};

export default initReviewsSlider;
